<template>
    <ion-page class="page-storage-sync">
        <ion-header class="tablet-header">
            <ion-toolbar>
                <ion-buttons slot="start">
                    <div class="shimmer-box back-button-shimmer"></div>
                </ion-buttons>
                <ion-title>
                    <div class="shimmer-box title-shimmer"></div>
                </ion-title>
            </ion-toolbar>
        </ion-header>

        <ion-content>
            <!-- Emergency Events Card Shimmer -->
            <ion-card>
                <ion-card-header>
                    <div class="shimmer-box card-title-shimmer"></div>
                </ion-card-header>
                <ion-card-content>
                    <ion-grid>
                        <!-- Row 1 -->
                        <ion-row>
                            <ion-col>
                                <div class="shimmer-box text-shimmer"></div>
                            </ion-col>
                            <ion-col>
                                <div class="shimmer-box text-shimmer-small"></div>
                            </ion-col>
                        </ion-row>
                        <!-- Row 2 -->
                        <ion-row>
                            <ion-col>
                                <div class="shimmer-box text-shimmer"></div>
                            </ion-col>
                            <ion-col>
                                <div class="shimmer-box text-shimmer-small"></div>
                            </ion-col>
                        </ion-row>
                        <!-- Button Row -->
                        <ion-row>
                            <ion-col>
                                <div class="shimmer-box button-shimmer"></div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-card-content>
            </ion-card>

            <!-- Pre-Plans Card Shimmer -->
            <ion-card>
                <ion-card-header>
                    <div class="shimmer-box card-title-shimmer"></div>
                </ion-card-header>
                <ion-card-content>
                    <ion-grid>
                        <!-- Row 1 -->
                        <ion-row>
                            <ion-col>
                                <div class="shimmer-box text-shimmer"></div>
                            </ion-col>
                            <ion-col>
                                <div class="shimmer-box text-shimmer-small"></div>
                            </ion-col>
                        </ion-row>
                        <!-- Row 2 -->
                        <ion-row>
                            <ion-col>
                                <div class="shimmer-box text-shimmer"></div>
                            </ion-col>
                            <ion-col>
                                <div class="shimmer-box text-shimmer-small"></div>
                            </ion-col>
                        </ion-row>
                        <!-- Button Row -->
                        <ion-row>
                            <ion-col>
                                <div class="shimmer-box button-shimmer"></div>
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-card-content>
            </ion-card>

            <!-- Content Sync Card Shimmer -->
            <ion-card>
                <ion-card-header>
                    <div class="shimmer-box card-subtitle-shimmer"></div>
                </ion-card-header>
                <ion-card-content>
                    <div class="shimmer-box text-block-shimmer"></div>
                    <div class="shimmer-box button-shimmer" style="margin-top: 16px;"></div>
                </ion-card-content>
            </ion-card>
        </ion-content>
    </ion-page>
</template>

<script>
export default {
    name: 'StorageSyncShimmer'
}
</script>

<style scoped>
.shimmer-box {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: 4px;
}

@keyframes shimmer {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

.back-button-shimmer {
    width: 40px;
    height: 40px;
    margin: 8px;
}

.title-shimmer {
    width: 80px;
    height: 24px;
}

.card-title-shimmer {
    width: 140px;
    height: 24px;
    margin-bottom: 8px;
}

.card-subtitle-shimmer {
    width: 120px;
    height: 20px;
    margin-bottom: 8px;
}

.text-shimmer {
    width: 100%;
    height: 16px;
    margin-bottom: 8px;
}

.text-shimmer-small {
    width: 40px;
    height: 16px;
    margin-bottom: 8px;
}

.text-block-shimmer {
    width: 100%;
    height: 48px;
    margin-bottom: 8px;
}

.button-shimmer {
    width: 100%;
    height: 48px;
}

ion-card {
    margin: 16px;
}
</style>
